import React, { useEffect, useState } from "react";
import { languageHelper } from "../../config/helperFunctions";

function POSNavOrderItem({
  order,
  handleSelectOrder,
  selectOrderId,
  handleOrderDetailModal,
  handleOrderDetails,
}) {
  const [orderDetail, showOrderDetail] = useState(true);
  const [orderTime, setOrderTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const createdAt = new Date(order.created_at);
      const now = new Date();
      const diffMs = now - createdAt;

      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
      const seconds = Math.floor((diffMs / 1000) % 60);

      setOrderTime(
        `${hours / 10 < 1 ? "0" : ""}${hours}:${
          minutes / 10 < 1 ? "0" : ""
        }${minutes}:${seconds / 10 < 1 ? "0" : ""}${seconds}`
      );
    };

    updateTime(); // run once immediately
    const interval = setInterval(updateTime, 1000); // update every second

    return () => clearInterval(interval); // cleanup on unmount
  }, [order.created_at]);

  return (
    <div
      className="bg-d-bg-dark w-[98%] p-1 rounded-lg my-2 font-medium ml-auto cursor-default select-none"
      onClick={() => handleSelectOrder(order)}
      onDoubleClick={() => {
        handleOrderDetails(order);
        handleOrderDetailModal(true);
      }}
    >
      <span className="flex items-center justify-between w-full">
        <span className={`${selectOrderId === order.id && "text-[#838087]"}`}>
          {" "}
          Order: {order.sale_no}{" "}
        </span>
        <button
          onClick={() => {
            showOrderDetail(!orderDetail);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`lucide lucide-chevron-right transition-all ${
              !orderDetail ? "rotate-90" : ""
            }`}
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </span>
      <div
        className={`grid transition-all ${
          orderDetail ? "grid-rows-[0fr]" : "grid-rows-[1fr]"
        }`}
      >
        <div className="flex flex-col w-full text-sm overflow-hidden">
          <span>
            {languageHelper("Table")}: {order.table?.name || "None"}
          </span>
          <span>
            {languageHelper("Waiter")}: {order.waiter_name}
          </span>
          <span>
            {languageHelper("Customer")}: {order.customer?.name}
          </span>
          <span>
            {languageHelper("Phone")}: {order.customer?.phone}
          </span>
          <hr className="font-bold" />
          <span>
            {languageHelper("Started Cooking")}:{" "}
            {order?.order_details?.filter(
              (item) => item.cooking_status === "started"
            )?.length || 0}{" "}
            / {order?.order_details?.length || 0}
          </span>
          <span>
            {languageHelper("Done")}:{" "}
            {order?.order_details?.filter(
              (item) => item.cooking_status === "ready"
            )?.length || 0}{" "}
            / {order?.order_details?.length || 0}
          </span>
          <hr />
          <span>
            {languageHelper("Time Count")}: {orderTime}
          </span>
        </div>
      </div>
    </div>
  );
}

export default POSNavOrderItem;
